import { Injectable } from '@angular/core';
import { AppActions } from '@app/app-actions.enum';
import { DataLayerService } from '@features/tag-manager/data-layer.service';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Collection } from './collection';
import { CollectionAction } from './collection-action.interface';
import { CollectionActions } from './collection-actions.enum';
import { CollectionEvent } from './collection-event.enum';
import { CollectionService } from './collection.service';

@Injectable()
export class CollectionEffects {
  constructor(
    private actions$: Actions,
    private collectionService: CollectionService,
    private datalayerService: DataLayerService,
  ) {}

  @Effect()
  createCollection = this.actions$.pipe(
    ofType(CollectionActions.CREATE_SUCCESS),
    mergeMap((action: CollectionAction) => {
      const collection = action.collection as Collection;

      this.datalayerService.push(CollectionEvent.addCollection, {
        id: collection.collectionId,
        name: collection.name,
        number_of_collections: this.collectionService.stateSnapshot.listOfCollections.length,
      });

      return EMPTY;
    }),
  );

  @Effect()
  deleteCollection = this.actions$.pipe(
    ofType(CollectionActions.DELETE_SUCCESS),
    mergeMap((action: CollectionAction) => {
      this.datalayerService.push(CollectionEvent.deleteCollection, {
        id: action.collectionId,
      });

      return EMPTY;
    }),
  );

  @Effect()
  fetchUserCollections$ = this.actions$.pipe(
    ofType(AppActions.LOAD_STATE_SUCCESS),
    map(() => ({ type: CollectionActions.UPDATE_LIST_REQUEST })),
  );

  @Effect()
  updateList$ = this.actions$.pipe(
    ofType(CollectionActions.UPDATE_LIST_REQUEST),
    mergeMap(() => this.collectionService.fetchCollections().pipe(
      map((collections) => ({
        type: CollectionActions.UPDATE_LIST_SUCCESS,
        collections,
      })),
      catchError((error) => of({ type: CollectionActions.UPDATE_LIST_ERROR, error })),
    )),
  );
}
